import type { SVGProps } from 'react';

const SvgFitnessReimbursement = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="m17.1 4.74-1.2 1.09L15 5A8.82 8.82 0 0 0 .15 11.07l1.5.06A7.32 7.32 0 0 1 14 6.07l1.38 1.33a.75.75 0 0 0 1 0l1.71-1.56A7.32 7.32 0 0 1 28 16.69L15.76 27.78 4.34 17.12l-1 1.1 11.9 11.13a.74.74 0 0 0 1 0L29 17.8A8.82 8.82 0 1 0 17.1 4.74" />
      <path d="M12.59 14.82 14.4 12l2.28 8.45a.77.77 0 0 0 .7.56.74.74 0 0 0 .7-.51l2-5.76h5.32v-1.5h-5.82a.74.74 0 0 0-.7.5l-1.39 4L15.4 10a.74.74 0 0 0-.6-.55.76.76 0 0 0-.75.34l-2.5 3.88H1.46v1.5H12a.75.75 0 0 0 .59-.35" />
    </g>
  </svg>
);

export default SvgFitnessReimbursement;
